

import React from 'react';

function ClipboardIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
            <path d="M9.00016 0.666992H1.66683C0.933496 0.666992 0.333496 1.26699 0.333496 2.00033V10.667C0.333496 11.0337 0.633496 11.3337 1.00016 11.3337C1.36683 11.3337 1.66683 11.0337 1.66683 10.667V2.66699C1.66683 2.30033 1.96683 2.00033 2.3335 2.00033H9.00016C9.36683 2.00033 9.66683 1.70033 9.66683 1.33366C9.66683 0.966992 9.36683 0.666992 9.00016 0.666992ZM11.6668 3.33366H4.3335C3.60016 3.33366 3.00016 3.93366 3.00016 4.66699V14.0003C3.00016 14.7337 3.60016 15.3337 4.3335 15.3337H11.6668C12.4002 15.3337 13.0002 14.7337 13.0002 14.0003V4.66699C13.0002 3.93366 12.4002 3.33366 11.6668 3.33366ZM11.0002 14.0003H5.00016C4.6335 14.0003 4.3335 13.7003 4.3335 13.3337V5.33366C4.3335 4.96699 4.6335 4.66699 5.00016 4.66699H11.0002C11.3668 4.66699 11.6668 4.96699 11.6668 5.33366V13.3337C11.6668 13.7003 11.3668 14.0003 11.0002 14.0003Z" fill="#777777"/>
        </svg>
    );
}

export default ClipboardIcon;